// import { useRoutes, Routes, Route, useNavigate } from 'react-router-dom';
// import React, { useState, useEffect, setState } from "react";
// import { useTour, TourProvider } from "@reactour/tour";
// import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
// import { element } from 'prop-types';

// import DashboardLayout from './layouts/dashboard';
// // layouts
// import Sidewise from './pages/Sidewise';
// import ViewLinks from './pages/ViewLinks';
// import ISPReports from './pages/ISP-Reports';
// import Alerts from './pages/Alerts';
// import Overview from './pages/Overview';
// import ISPGood from './components/ISPManagementTable/ISPManagementDashboard/ISPGood';
// import ISPBad from './components/ISPManagementTable/ISPManagementDashboard/ISPBad';
// import ISPDown from './components/ISPManagementTable/ISPManagementDashboard/ISPDown';
// import SidewiseGood from './components/SidewiseComponents/Components/SidewiseGood';
// import SidewiseBad from './components/SidewiseComponents/Components/SidewiseBad';
// import SidewiseDown from './components/SidewiseComponents/Components/SidewiseDown';
// import SidewiseTotalLinks from './components/SidewiseComponents/Components/SidewiseTotalLinks';
// import ISPGood1 from './components/ISPManagementTable/ISPManagementDashboard/ISPGood1/ISPGood1';
// import ISPBad1 from './components/ISPManagementTable/ISPManagementDashboard/ISPBad1/ISPBad1';
// import ISPDown1 from './components/ISPManagementTable/ISPManagementDashboard/ISPDown1/ISPDown1';

// import EdGood from './components/EdgeDevicesManagementTable/EdgeDevicesManagementDashboard/EdGood';
// import EdBad from './components/EdgeDevicesManagementTable/EdgeDevicesManagementDashboard/EdBad';
// import EdDown from './components/EdgeDevicesManagementTable/EdgeDevicesManagementDashboard/EdDown';

// import Login from './layouts/Login';
// import LogoOnlyLayout from './layouts/LogoOnlyLayout';
// import ResetPassword from './layouts/ResetPassword';
// import ForgotPassword from './layouts/ForgotPassword';
// import { ISPTotal } from './components/ISPManagementTable/ISPManagementDashboard';
// import AddSingleISP from './pages/AddSingleISP';
// import EditSingleISP from './pages/EditSingleISP';
// import UploadMultipleISP from './pages/UploadMultipleISP';
// import SiteDown from './pages/SiteDown';
// import AlertEmailConfig from './pages/AlertEmailConfig';
// import CreateNewUser from './pages/CreateNewUser';
// import ViewUsers from './pages/ViewUsers';
// import RegisterUsers from './pages/RegisterUsers';
// import PageNotFound from './pages/PageNotFound';
// import AddSingleLocation from './pages/AddSingleLocation';
// import ViewLocations from './pages/ViewLocations';
// import AuditLogs from './pages/AuditLogs';
// import Vendors from './pages/Vendors';
// import Zones from './pages/Zones';
// import ZoneLocationMapping from './pages/ZoneLocationMapping';
// import BusinessUnit from './pages/BusinessUnit'
// import BusinessUnitLocationMapping from './pages/BusinessLocationMapping';
// import PowerBiInsights from './pages/PowerBiInsights';
// import ValidateOtp from './layouts/ValidateOtp';
// import EnterOtp from './layouts/EnterOTP';
// import Templates from './pages/Templates';
// import HomePage from './pages/HomePage';
// import DownloadIso from './pages/DownloadIso';
// import SiteGroups from './pages/SiteGroups';
// import SiteGroupsLocationsMapping from './pages/SiteGroupsLocationsMapping';
// import EdgeDevices from './pages/EdgeDevices';

// import WizardLayout from './layouts/WizardLayout';
// import WizardForm from './pages/Wizard';

// import UpdateTourStatusAPICall from './pages/UpdateTourStatusAPICall';
// import ISPFlapping from './components/ISPManagementTable/ISPManagementDashboard/ISPFlapping';
// import Customers from './pages/Customers';
// import MspUsers from './pages/MspUsers';
// import LinksDevicesInventory from './pages/LinksDevicesInventory';
// import SystemAlertEmailConfig from './pages/SystemAlertEmailConfig';
// import EdgeDevicesOverview from './pages/EdgeDevicesOverview';
// import EdTotal from './components/EdgeDevicesManagementTable/EdgeDevicesManagementDashboard/EdTotal';
// import ISPPaused from './components/ISPManagementTable/ISPManagementDashboard/ISPPaused';

// import { EdGood1 } from './components/EdgeDevicesManagementTable/EdgeDevicesManagementDashboard/EdGood1';
// // import { EdBad1 } from './components/EdgeDevicesManagementTable/EdgeDevicesManagementDashboard/EdBad1';
// import { EdDown1 } from './components/EdgeDevicesManagementTable/EdgeDevicesManagementDashboard/EdDown1';

// import SAMonitor from './pages/SAMonitor';
// import AppMonitor from './pages/AppMonitor';
// import SaasApplications from './pages/SaasApplications';
// import ViewAgents from './pages/ViewAgents';

// import EdgeDevicesData from './pages/EdgeDevicesData';
// import EdLogs from './pages/EdLogs';
// import EdPaused from './components/EdgeDevicesManagementTable/EdgeDevicesManagementDashboard/EdPaused';
// import ViewLicenseComponent from './components/LicenseComponents/components/ViewLicenseComponent';
// import ISPFlapping1 from './components/ISPManagementTable/ISPManagementDashboard/ISPFlapping1/ISPFlapping1';
// import SystemLogs from './pages/SystemLog';
// import DecommisionedLogs from './pages/DecommisionedLogs';
// import AlertIMConfig from './pages/AlertIMConfig';
// import SiteUp from './pages/SiteUp';
// import NewReports from './pages/New-reports';
// import CreateNewTag from './pages/CreateNewTag';
// import SitetoSite from './pages/SiteToSite';
// import UtilizationConfig from './pages/UtilizationConfig';

// import InternalProbes from './pages/InternalProbes';
// import ProbeLocationMapping from './pages/ProbeLocationMapping';


// import LinksTableManagement from './pages/LinksTableManagement'
// import ViewWifi from './pages/ViewWifi';
// import Cloud from './pages/Cloud';
// import TotalCloudAssetsInfo from './components/CloudComponents/TotalCloudAssetsInfo';
// import TotalCloudAssets from'./pages/TotalCloudAssets';
// import DownAgentPage from './pages/DownAgentPage';

// // ----------------------------------------------------------------------
// export default function Router() {
//   const disableBody = target => disableBodyScroll(target);
//   const enableBody = target => enableBodyScroll(target);

//   const { setIsOpen } = useTour();
//   const [isShowingMore, setIsShowingMore] = useState(false);

//   const closeTour = (target) => {
//     enableBodyScroll(target);
//     UpdateTourStatusAPICall();

//   };
//   const steps = [
//     {
//       selector: '[data-tut="linkeyetour_home_sitessummarynumbers"]',
//       content: `This provides you the sites functioning summary..`
//     },
//     {
//       selector: '[data-tut="linkeyetour_home_changelogo"]',
//       content: `Update your company logo here..`
//     },
//     {
//       selector: '[data-tut="linkeyetour_home_producthelpdocument"]',
//       content: `You can view the product usage and help document here.`
//     },
//     {
//       selector: '[data-tut="linkeyetour_home_avgsitelinksla"]',
//       content: `This signifies your average site uptime, link uptime, SLA breaches and total site down time.`
//     },

//     {
//       selector: '[data-tut="linkeyetour_home_bestworstperforminglinkslist"]',
//       content: `This shows the list of best and worst performing links list.`
//     },
//     {
//       selector: '[data-tut="linkeyetour_home_bestworstperformingsiteslist"]',
//       content: `This shows the list of best and worst performing sites list.`
//     },
//     {
//       selector: '[data-tut="linkeyetour_home_totalgoodbaddownlinks"]',
//       content: `This shows the numbers of Total, Good, Bad and Down Links.`
//     },

//     {
//       selector: '[data-tut="linkeyetour_home_addmultipleedgedevices"]',
//       content: `You can add multiple Edge Devices by filling the template excel sheet and upload.`
//     },
//     {
//       selector: '[data-tut="linkeyetour_home_addmultiplelinks"]',
//       content: `You can add multiple links to linkeye by filling the excel sheet attached here.`
//     },
//     {
//       selector: '[data-tut="linkeyetour_home_connecttolocalprobe"]',
//       content: `You can connect your local probe by setting up the local probe server by following the probe installation documents.`
//     },
//   ];
//   const redirect = useNavigate();
//   const [step, setStep] = useState(0);
//   const setCurrentStep = (step) => {
//     switch (step) {
//       case 0:
//         redirect("/dashboard/home", true);
//         break;
//       case 1:
//         redirect("/dashboard/home", true);
//         break;
//       case 2:
//         redirect("/dashboard/home", true);
//         break;
//       case 3:
//         redirect("/dashboard/home", true);
//         break;
//       case 4:
//         redirect("/dashboard/home", true);
//         break;
//       case 5:
//         redirect("/dashboard/home", true);
//         break;

//       case 6:
//         redirect("/dashboard/isp-management", true);
//         break;

//       case 7:
//         redirect("/dashboard/view-locations", true);
//         break;
//       case 8:
//         redirect("/dashboard/upload-isp-csv", true);
//         break;
//       case 9:
//         redirect("/dashboard/download-iso", true);
//         break;
//       default:
//         break;
//     }
//     setStep(step);

//   };

//   const routes = [
//     {
//       path: '/',
//       element: <Login />,
//     },
//     {
//       path: '/dashboard',
//       element: <DashboardLayout />,
//       children: [
//         {
//           path: 'isp-sitewise',
//           element: <Sidewise />,
//           children: [
//             { path: '', element: <SidewiseTotalLinks /> },
//             { path: 'sidewise-good', element: <SidewiseGood /> },
//             { path: 'sidewise-bad', element: <SidewiseBad /> },
//             { path: 'sidewise-down', element: <SidewiseDown /> },
//           ]
//         },
//         { path: 'alerts', element: <Alerts /> },
//         { path: 'view-isp', element: <ViewLinks /> },
//         { path: 'view-wifi', element: <ViewWifi /> },
//         { path: 'link-devices-inventory', element: <LinksDevicesInventory /> },
//         { path: 'isp-reports', element: <ISPReports /> },
//         { path: 'app-monitor-dashboard/:locationId', element: <AppMonitor /> },
//         {
//           path: 'isp-management',
//           element: <Overview />,
//           children: [
//             { path: 'isp-good', element: <ISPGood /> },
//             { path: 'isp-bad', element: <ISPBad /> },
//             { path: 'isp-total', element: <ISPTotal /> },
//             { path: 'isp-flapping', element: <ISPFlapping /> },
//             { path: 'isp-paused', element: <ISPPaused /> },
//             { path: '', element: <ISPDown /> },
//           ]
//         },
//         {
//           path: 'edge-device-management',
//           element: <EdgeDevicesOverview />,
//           children: [
//             { path: '', element: <EdGood /> },
//             { path: 'edge-device-bad', element: <EdBad /> },
//             { path: 'edge-device-total', element: <EdTotal /> },
//             { path: 'edge-device-down', element: <EdDown /> },
//             { path: 'edge-device-paused', element: <EdPaused /> },
//           ]
//         },
//         {
//           path: 'edge-device-data',
//           element: <EdgeDevicesData />,
//         },
//         {
//           path: 'home', element: <HomePage />
//         },
//         { path: 'add-single-isp/', element: <AddSingleISP /> },
//         { path: 'edit-single-isp/:id', element: <EditSingleISP /> },
//         {
//           path: 'upload-isp-csv', element: <UploadMultipleISP openTour={() => setIsOpen(true)}
//             toggleShowMore={() => setIsShowingMore((m) => !m)}
//             isShowingMore={isShowingMore} />
//         },
//         // { path: 'isp-management/isp-good/:id', element: <ISPGood1 /> },
//         // { path: 'isp-management/isp-bad/:id', element: <ISPBad1 /> },
//         // { path: 'isp-management/isp-down/:id', element: <ISPDown1 /> },
//         // { path: 'isp-management/isp-flapping/:id/:status', element: <ISPFlapping1 /> },
//         {
//           path: 'isp-management/isp-good/:id',
//           element: <ISPGood1 />,
//           children: [
//             {
//               path: ':sitename',
//               element: <ISPGood1 />
//             }
//           ]
//         },
//         {
//           path: 'isp-management/isp-bad/:id',
//           element: <ISPBad1 />,
//           children: [
//             {
//               path: ':sitename',
//               element: <ISPBad1 />
//             }
//           ]
//         },
//         {
//           path: 'isp-management/isp-down/:id',
//           element: <ISPDown1 />,
//           children: [
//             {
//               path: ':sitename',
//               element: <ISPDown1 />
//             }
//           ]
//         },
//         {
//           path: 'isp-management/isp-flapping/:id/:status',
//           element: <ISPFlapping1 />,
//           children: [
//             {
//               path: ':sitename',
//               element: <ISPFlapping1 />
//             }
//           ]
//         },


        
//         {
//           path: 'edge-device-management/ed-good/:id',
//           element: <EdGood1 />,
//           children: [
//             {
//               path: ':sitename',
//               element: <EdGood1 />
//             }
//           ]
//         },
        
       
//           {
//           path: 'edge-device-management/ed-down/:id',
//           element: <EdDown1 />,
//           children: [
//             {
//               path: ':sitename',
//               element: <EdDown1 />
//             }
//           ]
//         },

//         { path: 'site-up', element: <SiteUp /> },
//         { path: 'site-down', element: <SiteDown /> },
//         { path: 'down-dc-agent', element: <DownAgentPage /> },
//         { path: 'alert-email-config', element: <AlertEmailConfig /> },
//         { path: 'alert-im-config', element: <AlertIMConfig /> },
//         { path: 'system-alert-email-config', element: <SystemAlertEmailConfig /> },
//         // Utilization
//         { path: 'utilization-Config', element: <UtilizationConfig /> },

//         // User Components
//         { path: 'create-new-user/', element: <CreateNewUser /> },
//         { path: 'view-users/', element: <ViewUsers /> },
//         { path: 'Register-Users/', element: <RegisterUsers /> },

//         // create ur component path

//         // Tag Management
//         { path: 'create-new-tag', element: <CreateNewTag /> },

//         // View Management
//         { path: 'link-table-management', element: <LinksTableManagement /> },

//         // Location Components
//         { path: 'add-single-location', element: <AddSingleLocation /> },
//         { path: 'view-locations', element: <ViewLocations /> },

//         // Edge Devices
//         { path: 'view-edge-devices', element: <EdgeDevices /> },

//         // Site-Groups
//         { path: 'site-groups', element: <SiteGroups /> },
//         { path: 'site-group-location-map', element: <SiteGroupsLocationsMapping /> },

//         // Logs
//         { path: 'audit-logs', element: <AuditLogs /> },
//         { path: 'system-logs', element: <SystemLogs /> },
//         { path: 'ed-logs', element: <EdLogs /> },
//         { path: 'decommisioned-logs', element: <DecommisionedLogs /> },

//         // Vendors
//         { path: 'vendors', element: <Vendors /> },

//         // Templates
//         { path: 'templates', element: <Templates /> },

//         // Zones
//         { path: 'zones', element: <Zones /> },
//         { path: 'zone-location-map', element: <ZoneLocationMapping /> },
//         // { path:'zone-parameters', element:<ZoneParameters />},

//         // Business-unit
//         { path: 'business-unit', element: <BusinessUnit /> },
//         { path: 'business-unit-location-map', element: <BusinessUnitLocationMapping /> },

//         // Reports
//         { path: 'power-bi-insights', element: <PowerBiInsights /> },

//         // Download OVF
//         { path: 'download-iso', element: <DownloadIso /> },

//         { path: 'wizard', element: <WizardForm /> },

//         { path: 'customers', element: <Customers /> },

//         { path: 'msp-users', element: <MspUsers /> },

//         { path: 'sa-monitor', element: <SAMonitor /> },

//         // { path: 'app-monitor-dashboard', element: <AppMonitor /> },

//         { path: 'view-apps', element: <SaasApplications /> },


//         { path: 'Site-to-Site', element: < SitetoSite /> },

//         { path: 'view-agents', element: <ViewAgents /> },

//         { path: 'view-license', element: <ViewLicenseComponent /> },

//         { path: 'view-license', element: <ViewLicenseComponent /> },

//         // reports path
//         { path: 'reports', element: <NewReports /> },
//         { path: 'internal-probes', element: <InternalProbes /> },
//         { path: 'probe-location-mapping', element: <ProbeLocationMapping /> },

//         { path: 'cloud', element: <Cloud /> },

//         //  { path : 'cloud/toal-cloud-assets/:id',  element : <TotalCloudAssetsInfo/>}
//         { path: 'cloud/toal-cloud-assets/:id', element: <TotalCloudAssets /> }


//       ]
//     },
//     {
//       path: '/logout',
//       element: <LogoOnlyLayout />
//     },
//     {
//       path: 'forgot-password',
//       element: <ForgotPassword />
//     },
//     {
//       path: 'validate-otp',
//       element: <ValidateOtp />
//     },
//     {
//       path: 'reset-password',
//       element: <ResetPassword />
//     },
//     {
//       path: 'enter-otp',
//       element: <EnterOtp />
//     },
//     {
//       path: '*',
//       element: <PageNotFound />
//     },
//     {
//       path: 'wizard-form', element: <WizardLayout />
//     },


//   ]
//   return (<TourProvider
//     steps={steps}
//     currentStep={step}
//     beforeClose={closeTour}
//     afterOpen={disableBody}
//     setCurrentStep={setCurrentStep}
//     disableInteraction={false}
//   > {useRoutes(routes)}
//   </TourProvider>);
// }



import React, { useState, useEffect, Suspense, lazy } from "react";
import { useRoutes, Routes, Route, useNavigate } from 'react-router-dom';
import { useTour, TourProvider } from "@reactour/tour";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import Chatbot from "./pages/ChatBot";
import { EdPaused1 } from "./components/EdgeDevicesManagementTable/EdgeDevicesManagementDashboard/EdPaused1";
// import { element } from 'prop-types'; // If not used, consider removing this line entirely

// ----------------------------------------------------------------------
// LAZY LOADING UTILITY
// This utility will handle both default and named exports for lazy loading
const lazyLoad = (importFactory, chunkName) => {
  // If the importFactory returns a promise that resolves to a module
  // where the component is a named export, we need to extract it.
  // We'll try to infer if it's a named export based on how it's used
  // in your original imports (e.g., `import { ComponentName } from '...'`).
  // For simplicity, we'll assume most are default exports,
  // but for known named exports like EdGood1, we'll explicitly handle them.
  return lazy(() => importFactory().then(module => {
    // Check if the module itself is the component (default export)
    // or if it's an object with a default property.
    // Also, specifically handle cases like { ComponentName } where ComponentName is a named export.
    if (module.default) {
      return { default: module.default };
    }
    // This is a fallback for named exports where module.ComponentName is the component
    // You might need to adjust 'module.EdGood1' or 'module.EdDown1' if other named exports cause issues.
    // However, it's always best to change the component file to 'export default'.
    // For now, let's explicitly handle the ones we know are named based on your error.
    // This is less generic and relies on knowledge of specific named exports.
    // A more robust solution involves ensuring all lazy-loaded components use 'export default'.
    if (chunkName === 'EdGood1' && module.EdGood1) {
      return { default: module.EdGood1 };
    }
    if (chunkName === 'EdDown1' && module.EdDown1) {
      return { default: module.EdDown1 };
    }
    if (chunkName === 'ISPTotal' && module.ISPTotal) { // Based on your original import: `import { ISPTotal } from '...'`
      return { default: module.ISPTotal };
    }
    // Fallback if none of the above, this might still cause errors for other named exports.
    console.warn(`Lazy loaded component '${chunkName}' might be using named export. Consider changing it to 'export default'.`);
    return module; // Attempt to return the module as is, hoping it's a default.
  }));
};


// =====================================================================
// LAZY LOADED COMPONENTS - Grouped for clarity
// =====================================================================

// LAYOUTS
const DashboardLayout = lazyLoad(() => import('./layouts/dashboard'), 'DashboardLayout');
const Login = lazyLoad(() => import('./layouts/Login'), 'Login');
const LogoOnlyLayout = lazyLoad(() => import('./layouts/LogoOnlyLayout'), 'LogoOnlyLayout');
const ResetPassword = lazyLoad(() => import('./layouts/ResetPassword'), 'ResetPassword');
const ForgotPassword = lazyLoad(() => import('./layouts/ForgotPassword'), 'ForgotPassword');
const ValidateOtp = lazyLoad(() => import('./layouts/ValidateOtp'), 'ValidateOtp');
const EnterOtp = lazyLoad(() => import('./layouts/EnterOTP'), 'EnterOtp');
const WizardLayout = lazyLoad(() => import('./layouts/WizardLayout'), 'WizardLayout');

// MAIN DASHBOARD PAGES / FEATURES
const Sidewise = lazyLoad(() => import('./pages/Sidewise'), 'Sidewise');
const ViewLinks = lazyLoad(() => import('./pages/ViewLinks'), 'ViewLinks');
const ISPReports = lazyLoad(() => import('./pages/ISP-Reports'), 'ISPReports');
const Alerts = lazyLoad(() => import('./pages/Alerts'), 'Alerts');
const Overview = lazyLoad(() => import('./pages/Overview'), 'Overview'); // Parent for ISP Management

const ChatBot = lazyLoad(()=>import('./pages/ChatBot'), 'ChatBot');
const HomePage = lazyLoad(() => import('./pages/HomePage'), 'HomePage');
const AddSingleISP = lazyLoad(() => import('./pages/AddSingleISP'), 'AddSingleISP');
const EditSingleISP = lazyLoad(() => import('./pages/EditSingleISP'), 'EditSingleISP');
const UploadMultipleISP = lazyLoad(() => import('./pages/UploadMultipleISP'), 'UploadMultipleISP');
const SiteDown = lazyLoad(() => import('./pages/SiteDown'), 'SiteDown');
const SitesPartiallyUp = lazyLoad(() => import('./pages/SitesPartiallyUp'), 'SitesPartiallyUp');
const SitesRunningOnOneLink = lazyLoad(() => import('./pages/SitesRunningOnOneLink'), 'SitesRunningOnOneLink');
const AlertEmailConfig = lazyLoad(() => import('./pages/AlertEmailConfig'), 'AlertEmailConfig');
const CreateNewUser = lazyLoad(() => import('./pages/CreateNewUser'), 'CreateNewUser');
const ViewUsers = lazyLoad(() => import('./pages/ViewUsers'), 'ViewUsers');
const RegisterUsers = lazyLoad(() => import('./pages/RegisterUsers'), 'RegisterUsers');
const PageNotFound = lazyLoad(() => import('./pages/PageNotFound'), 'PageNotFound');
const AddSingleLocation = lazyLoad(() => import('./pages/AddSingleLocation'), 'AddSingleLocation');
const ViewLocations = lazyLoad(() => import('./pages/ViewLocations'), 'ViewLocations');
const AuditLogs = lazyLoad(() => import('./pages/AuditLogs'), 'AuditLogs');
const Vendors = lazyLoad(() => import('./pages/Vendors'), 'Vendors');
const Zones = lazyLoad(() => import('./pages/Zones'), 'Zones');
const ZoneLocationMapping = lazyLoad(() => import('./pages/ZoneLocationMapping'), 'ZoneLocationMapping');
const BusinessUnit = lazyLoad(() => import('./pages/BusinessUnit'), 'BusinessUnit');
const BusinessUnitLocationMapping = lazyLoad(() => import('./pages/BusinessLocationMapping'), 'BusinessUnitLocationMapping');
const PowerBiInsights = lazyLoad(() => import('./pages/PowerBiInsights'), 'PowerBiInsights');
const Templates = lazyLoad(() => import('./pages/Templates'), 'Templates');
const DownloadIso = lazyLoad(() => import('./pages/DownloadIso'), 'DownloadIso');
const SiteGroups = lazyLoad(() => import('./pages/SiteGroups'), 'SiteGroups');
const SiteGroupsLocationsMapping = lazyLoad(() => import('./pages/SiteGroupsLocationsMapping'), 'SiteGroupsLocationsMapping');
const EdgeDevices = lazyLoad(() => import('./pages/EdgeDevices'), 'EdgeDevices');
const WizardForm = lazyLoad(() => import('./pages/Wizard'), 'WizardForm');
const UpdateTourStatusAPICall = lazyLoad(() => import('./pages/UpdateTourStatusAPICall'), 'UpdateTourStatusAPICall');
const Customers = lazyLoad(() => import('./pages/Customers'), 'Customers');
const MspUsers = lazyLoad(() => import('./pages/MspUsers'), 'MspUsers');
const LinksDevicesInventory = lazyLoad(() => import('./pages/LinksDevicesInventory'), 'LinksDevicesInventory');
const SystemAlertEmailConfig = lazyLoad(() => import('./pages/SystemAlertEmailConfig'), 'SystemAlertEmailConfig');
const EdgeDevicesOverview = lazyLoad(() => import('./pages/EdgeDevicesOverview'), 'EdgeDevicesOverview'); // Parent for ED Management
const SAMonitor = lazyLoad(() => import('./pages/SAMonitor'), 'SAMonitor');
const AppMonitor = lazyLoad(() => import('./pages/AppMonitor'), 'AppMonitor');
const SaasApplications = lazyLoad(() => import('./pages/SaasApplications'), 'SaasApplications');
const ViewAgents = lazyLoad(() => import('./pages/ViewAgents'), 'ViewAgents');
const EdgeDevicesData = lazyLoad(() => import('./pages/EdgeDevicesData'), 'EdgeDevicesData');
const EdLogs = lazyLoad(() => import('./pages/EdLogs'), 'EdLogs');
const SystemLogs = lazyLoad(() => import('./pages/SystemLog'), 'SystemLogs');
const DecommisionedLogs = lazyLoad(() => import('./pages/DecommisionedLogs'), 'DecommisionedLogs');
const AlertIMConfig = lazyLoad(() => import('./pages/AlertIMConfig'), 'AlertIMConfig');
const SiteUp = lazyLoad(() => import('./pages/SiteUp'), 'SiteUp');
const NewReports = lazyLoad(() => import('./pages/New-reports'), 'NewReports');
const CreateNewTag = lazyLoad(() => import('./pages/CreateNewTag'), 'CreateNewTag');
const SitetoSite = lazyLoad(() => import('./pages/SiteToSite'), 'SitetoSite');
const UtilizationConfig = lazyLoad(() => import('./pages/UtilizationConfig'), 'UtilizationConfig');
const InternalProbes = lazyLoad(() => import('./pages/InternalProbes'), 'InternalProbes');
const ProbeLocationMapping = lazyLoad(() => import('./pages/ProbeLocationMapping'), 'ProbeLocationMapping');
const LinksTableManagement = lazyLoad(() => import('./pages/LinksTableManagement'), 'LinksTableManagement');
const ViewWifi = lazyLoad(() => import('./pages/ViewWifi'), 'ViewWifi');
const Cloud = lazyLoad(() => import('./pages/Cloud'), 'Cloud');
const TotalCloudAssets = lazyLoad(() => import('./pages/TotalCloudAssets'), 'TotalCloudAssets');
const DownAgentPage = lazyLoad(() => import('./pages/DownAgentPage'), 'DownAgentPage');

// NESTED COMPONENTS (loaded when their specific sub-route is activated)
const SidewiseGood = lazyLoad(() => import('./components/SidewiseComponents/Components/SidewiseGood'), 'SidewiseGood');
const SidewiseBad = lazyLoad(() => import('./components/SidewiseComponents/Components/SidewiseBad'), 'SidewiseBad');
const SidewiseDown = lazyLoad(() => import('./components/SidewiseComponents/Components/SidewiseDown'), 'SidewiseDown');
const SidewiseTotalLinks = lazyLoad(() => import('./components/SidewiseComponents/Components/SidewiseTotalLinks'), 'SidewiseTotalLinks');

const ISPGood = lazyLoad(() => import('./components/ISPManagementTable/ISPManagementDashboard/ISPGood'), 'ISPGood');
const ISPBad = lazyLoad(() => import('./components/ISPManagementTable/ISPManagementDashboard/ISPBad'), 'ISPBad');
const ISPDown = lazyLoad(() => import('./components/ISPManagementTable/ISPManagementDashboard/ISPDown'), 'ISPDown');
// Special handling for ISPTotal because it's imported as a named export
const ISPTotal = lazyLoad(() => import('./components/ISPManagementTable/ISPManagementDashboard').then(module => ({ default: module.ISPTotal })), 'ISPTotal');
const ISPFlapping = lazyLoad(() => import('./components/ISPManagementTable/ISPManagementDashboard/ISPFlapping'), 'ISPFlapping');
const ISPPaused = lazyLoad(() => import('./components/ISPManagementTable/ISPManagementDashboard/ISPPaused'), 'ISPPaused');
const NotMonitored = lazyLoad(() => import('./components/ISPManagementTable/ISPManagementDashboard/NotMonitored'), 'NotMonitored');
const ISPGood1 = lazyLoad(() => import('./components/ISPManagementTable/ISPManagementDashboard/ISPGood1/ISPGood1'), 'ISPGood1');
const ISPBad1 = lazyLoad(() => import('./components/ISPManagementTable/ISPManagementDashboard/ISPBad1/ISPBad1'), 'ISPBad1');
const ISPDown1 = lazyLoad(() => import('./components/ISPManagementTable/ISPManagementDashboard/ISPDown1/ISPDown1'), 'ISPDown1');
const NotMonitored1 = lazyLoad(() => import('./components/ISPManagementTable/ISPManagementDashboard/NotMonitoredCard/NotMonitored1'), 'NotMonitored1');
const ISPFlapping1 = lazyLoad(() => import('./components/ISPManagementTable/ISPManagementDashboard/ISPFlapping1/ISPFlapping1'), 'ISPFlapping1');

const EdGood = lazyLoad(() => import('./components/EdgeDevicesManagementTable/EdgeDevicesManagementDashboard/EdGood'), 'EdGood');
const EdBad = lazyLoad(() => import('./components/EdgeDevicesManagementTable/EdgeDevicesManagementDashboard/EdBad'), 'EdBad');
const EdDown = lazyLoad(() => import('./components/EdgeDevicesManagementTable/EdgeDevicesManagementDashboard/EdDown'), 'EdDown');
const EdTotal = lazyLoad(() => import('./components/EdgeDevicesManagementTable/EdgeDevicesManagementDashboard/EdTotal'), 'EdTotal');
const EdPaused = lazyLoad(() => import('./components/EdgeDevicesManagementTable/EdgeDevicesManagementDashboard/EdPaused'), 'EdPaused');

// Explicitly handle named exports for EdGood1 and EdDown1 as per the error
const EdGood1 = lazyLoad(() => import('./components/EdgeDevicesManagementTable/EdgeDevicesManagementDashboard/EdGood1').then(module => ({ default: module.EdGood1 })), 'EdGood1');
// const EdPaused1 = lazyLoad(() => import('./components/EdgeDevicesManagementTable/EdgeDevicesManagementDashboard/EdPaused1').then(module => ({ default: module.EdPaused1 })), 'EdPaused1'); 
const EdDown1 = lazyLoad(() => import('./components/EdgeDevicesManagementTable/EdgeDevicesManagementDashboard/EdDown1').then(module => ({ default: module.EdDown1 })), 'EdDown1');

// ----------------------------------------------------------------------
export default function Router() {
  const disableBody = target => disableBodyScroll(target);
  const enableBody = target => enableBodyScroll(target);

  const { setIsOpen } = useTour();
  const [isShowingMore, setIsShowingMore] = useState(false);

  const closeTour = (target) => {
    enableBodyScroll(target);
    // Ensure this API call is either very fast or handled asynchronously without blocking UI
    // UpdateTourStatusAPICall needs to be imported if it's a function from a file.
    // If it's a global function, keep as is. Assuming it's a component, it should be loaded.
    // For tour actions, it's often a simple utility, so we'll keep it as a direct call for now.
    UpdateTourStatusAPICall();
  };

  const steps = [
    {
      selector: '[data-tut="linkeyetour_home_sitessummarynumbers"]',
      content: `This provides you the sites functioning summary..`
    },
    {
      selector: '[data-tut="linkeyetour_home_changelogo"]',
      content: `Update your company logo here..`
    },
    {
      // This looks like a typo: 'CORNFLAKES' should likely be 'selector'
      selector: '[data-tut="linkeyetour_home_producthelpdocument"]',
      content: `You can view the product usage and help document here.`
    },
    {
      selector: '[data-tut="linkeyetour_home_avgsitelinksla"]',
      content: `This signifies your average site uptime, link uptime, SLA breaches and total site down time.`
    },
    {
      selector: '[data-tut="linkeyetour_home_bestworstperforminglinkslist"]',
      content: `This shows the list of best and worst performing links list.`
    },
    {
      selector: '[data-tut="linkeyetour_home_bestworstperformingsiteslist"]',
      content: `This shows the list of best and worst performing sites list.`
    },
    {
      selector: '[data-tut="linkeyetour_home_totalgoodbaddownlinks"]',
      content: `This shows the numbers of Total, Good, Bad and Down Links.`
    },
    {
      selector: '[data-tut="linkeyetour_home_addmultipleedgedevices"]',
      content: `You can add multiple Edge Devices by filling the template excel sheet and upload.`
    },
    {
      selector: '[data-tut="linkeyetour_home_addmultiplelinks"]',
      content: `You can add multiple links to linkeye by filling the excel sheet attached here.`
    },
    {
      selector: '[data-tut="linkeyetour_home_connecttolocalprobe"]',
      content: `You can connect your local probe by setting up the local probe server by following the probe installation documents.`
    },
  ];

  const redirect = useNavigate();
  const [step, setStep] = useState(0);

  const setCurrentStep = (step) => {
    switch (step) {
      case 0: redirect("/dashboard/home", true); break;
      case 1: redirect("/dashboard/home", true); break;
      case 2: redirect("/dashboard/home", true); break;
      case 3: redirect("/dashboard/home", true); break;
      case 4: redirect("/dashboard/home", true); break;
      case 5: redirect("/dashboard/home", true); break;
      case 6: redirect("/dashboard/isp-management", true); break;
      case 7: redirect("/dashboard/view-locations", true); break;
      case 8: redirect("/dashboard/upload-isp-csv", true); break;
      case 9: redirect("/dashboard/download-iso", true); break;
      default: break;
    }
    setStep(step);
  };

  const routes = [
    {
      path: '/',
      element: (
        <Suspense fallback={null}> {/* Render null for initial login load */}
          <Login />
        </Suspense>
      ),
    },
    {
      path: '/dashboard',
      element: (
        <Suspense fallback={null}> {/* Render null for DashboardLayout load */}
          <DashboardLayout />
        </Suspense>
      ),
      children: [
        {
          path: 'isp-sitewise',
          element: (
            <Suspense fallback={null}>
              <Sidewise />
            </Suspense>
          ),
          children: [
            { path: '', element: <Suspense fallback={null}><SidewiseTotalLinks /></Suspense> },
            { path: 'sidewise-good', element: <Suspense fallback={null}><SidewiseGood /></Suspense> },
            { path: 'sidewise-bad', element: <Suspense fallback={null}><SidewiseBad /></Suspense> },
            { path: 'sidewise-down', element: <Suspense fallback={null}><SidewiseDown /></Suspense> },
          ]
        },
        { path: 'alerts', element: <Suspense fallback={null}><Alerts /></Suspense> },
        { path: 'view-isp', element: <Suspense fallback={null}><ViewLinks /></Suspense> },
        { path: 'view-wifi', element: <Suspense fallback={null}><ViewWifi /></Suspense> },
        { path: 'link-devices-inventory', element: <Suspense fallback={null}><LinksDevicesInventory /></Suspense> },
        { path: 'isp-reports', element: <Suspense fallback={null}><ISPReports /></Suspense> },
        { path: 'app-monitor-dashboard/:locationId', element: <Suspense fallback={null}><AppMonitor /></Suspense> },
        {
          path: 'isp-management',
          element: (
            <Suspense fallback={null}>
              <Overview /> {/* Parent for ISP Management */}
            </Suspense>
          ),
          children: [
            { path: 'isp-good', element: <Suspense fallback={null}><ISPGood /></Suspense> },
            { path: 'isp-bad', element: <Suspense fallback={null}><ISPBad /></Suspense> },
            { path: 'isp-total', element: <Suspense fallback={null}><ISPTotal /></Suspense> }, // ISPTotal is a named export
            { path: 'isp-flapping', element: <Suspense fallback={null}><ISPFlapping /></Suspense> },
            { path: 'isp-paused', element: <Suspense fallback={null}><ISPPaused /></Suspense> },
            { path: 'not-monitored', element: <Suspense fallback={null}><NotMonitored /></Suspense> },
            { path: '', element: <Suspense fallback={null}><ISPDown /></Suspense> }, // Default for isp-management
          ]
        },
        {
          path: 'edge-device-management',
          element: (
            <Suspense fallback={null}>
              <EdgeDevicesOverview /> {/* Parent for Edge Device Management */}
            </Suspense>
          ),
          children: [
            { path: '', element: <Suspense fallback={null}><EdGood /></Suspense> }, // Default for edge-device-management
            { path: 'edge-device-bad', element: <Suspense fallback={null}><EdBad /></Suspense> },
            { path: 'edge-device-total', element: <Suspense fallback={null}><EdTotal /></Suspense> },
            { path: 'edge-device-down', element: <Suspense fallback={null}><EdDown /></Suspense> },
            { path: 'edge-device-paused', element: <Suspense fallback={null}><EdPaused /></Suspense> },
          ]
        },
        {path : 'ai-chatbot',
          element:(
             <Suspense fallback={null}>
             <ChatBot />
            </Suspense>
          ),
        },
        {
          path: 'edge-device-data',
          element: <Suspense fallback={null}><EdgeDevicesData /></Suspense>,
        },
        {
          path: 'home', element: <Suspense fallback={null}><HomePage /></Suspense>
        },
        { path: 'add-single-isp/', element: <Suspense fallback={null}><AddSingleISP /></Suspense> },
        { path: 'edit-single-isp/:id', element: <Suspense fallback={null}><EditSingleISP /></Suspense> },
        {
          path: 'upload-isp-csv', element: <Suspense fallback={null}><UploadMultipleISP openTour={() => setIsOpen(true)}
            toggleShowMore={() => setIsShowingMore((m) => !m)}
            isShowingMore={isShowingMore} /></Suspense>
        },
        // ISP Management nested detail routes
        {
          path: 'isp-management/isp-good/:id',
          element: <Suspense fallback={null}><ISPGood1 /></Suspense>,
          children: [
            { path: ':sitename', element: <Suspense fallback={null}><ISPGood1 /></Suspense> }
          ]
        },
        {
          path: 'isp-management/isp-bad/:id',
          element: <Suspense fallback={null}><ISPBad1 /></Suspense>,
          children: [
            { path: ':sitename', element: <Suspense fallback={null}><ISPBad1 /></Suspense> }
          ]
        },
        {
          path: 'isp-management/isp-down/:id',
          element: <Suspense fallback={null}><ISPDown1 /></Suspense>,
          children: [
            { path: ':sitename', element: <Suspense fallback={null}><ISPDown1 /></Suspense> }
          ]
        },
          {
          path: 'isp-management/isp-paused/:id',
          element: <Suspense fallback={null}><ISPDown1 /></Suspense>,
          children: [
            { path: ':sitename', element: <Suspense fallback={null}><ISPDown1 /></Suspense> }
          ]
        },
         {
          path: 'isp-management/not-monitored/:id',
          element: <Suspense fallback={null}><NotMonitored1 /></Suspense>,
          children: [
            { path: ':sitename', element: <Suspense fallback={null}><NotMonitored1 /></Suspense> }
          ]
        },
        {
          path: 'isp-management/isp-flapping/:id/:status',
          element: <Suspense fallback={null}><ISPFlapping1 /></Suspense>,
          children: [
            { path: ':sitename', element: <Suspense fallback={null}><ISPFlapping1 /></Suspense> }
          ]
        },
        // Edge Device Management nested detail routes
        {
          path: 'edge-device-management/ed-good/:id',
          element: <Suspense fallback={null}><EdGood1 /></Suspense>,
          children: [
            { path: ':sitename', element: <Suspense fallback={null}><EdGood1 /></Suspense> }
          ]
        },
        {
          path: 'edge-device-management/ed-down/:id',
          element: <Suspense fallback={null}><EdDown1 /></Suspense>,
          children: [
            { path: ':sitename', element: <Suspense fallback={null}><EdDown1 /></Suspense> }
          ]
        },
          {
          path: 'edge-device-management/ed-paused/:id',
          element: <Suspense fallback={null}><EdPaused1 /></Suspense>,
          children: [
            { path: ':sitename', element: <Suspense fallback={null}><EdPaused1 /></Suspense> }
          ]
        },
        { path: 'site-up', element: <Suspense fallback={null}><SiteUp /></Suspense> },
        { path: 'site-down', element: <Suspense fallback={null}><SiteDown /></Suspense> },
        { path: 'Site-Partially-Up', element: <Suspense fallback={null}><SitesPartiallyUp /></Suspense> },
         { path: 'Site Running on 1 Link', element: <Suspense fallback={null}><SitesRunningOnOneLink /></Suspense> },
        { path: 'down-dc-agent', element: <Suspense fallback={null}><DownAgentPage /></Suspense> },
        { path: 'alert-email-config', element: <Suspense fallback={null}><AlertEmailConfig /></Suspense> },
        { path: 'alert-im-config', element: <Suspense fallback={null}><AlertIMConfig /></Suspense> },
        { path: 'system-alert-email-config', element: <Suspense fallback={null}><SystemAlertEmailConfig /></Suspense> },
        // Utilization
        { path: 'utilization-Config', element: <Suspense fallback={null}><UtilizationConfig /></Suspense> },
        // User Components
        { path: 'create-new-user/', element: <Suspense fallback={null}><CreateNewUser /></Suspense> },
        { path: 'view-users/', element: <Suspense fallback={null}><ViewUsers /></Suspense> },
        { path: 'Register-Users/', element: <Suspense fallback={null}><RegisterUsers /></Suspense> },
        // Tag Management
        { path: 'create-new-tag', element: <Suspense fallback={null}><CreateNewTag /></Suspense> },
        // View Management
        { path: 'link-table-management', element: <Suspense fallback={null}><LinksTableManagement /></Suspense> },
        // Location Components
        { path: 'add-single-location', element: <Suspense fallback={null}><AddSingleLocation /></Suspense> },
        { path: 'view-locations', element: <Suspense fallback={null}><ViewLocations /></Suspense> },
        // Edge Devices
        { path: 'view-edge-devices', element: <Suspense fallback={null}><EdgeDevices /></Suspense> },
        // Site-Groups
        { path: 'site-groups', element: <Suspense fallback={null}><SiteGroups /></Suspense> },
        { path: 'site-group-location-map', element: <Suspense fallback={null}><SiteGroupsLocationsMapping /></Suspense> },
        // Logs
        { path: 'audit-logs', element: <Suspense fallback={null}><AuditLogs /></Suspense> },
        { path: 'system-logs', element: <Suspense fallback={null}><SystemLogs /></Suspense> },
        { path: 'ed-logs', element: <Suspense fallback={null}><EdLogs /></Suspense> },
        { path: 'decommisioned-logs', element: <Suspense fallback={null}><DecommisionedLogs /></Suspense> },
        // Vendors
        { path: 'vendors', element: <Suspense fallback={null}><Vendors /></Suspense> },
        // Templates
        { path: 'templates', element: <Suspense fallback={null}><Templates /></Suspense> },
        // Zones
        { path: 'zones', element: <Suspense fallback={null}><Zones /></Suspense> },
        { path: 'zone-location-map', element: <Suspense fallback={null}><ZoneLocationMapping /></Suspense> },
        // Business-unit
        { path: 'business-unit', element: <Suspense fallback={null}><BusinessUnit /></Suspense> },
        { path: 'business-unit-location-map', element: <Suspense fallback={null}><BusinessUnitLocationMapping /></Suspense> },
        // Reports
        { path: 'power-bi-insights', element: <Suspense fallback={null}><PowerBiInsights /></Suspense> },
        // Download OVF
        { path: 'download-iso', element: <Suspense fallback={null}><DownloadIso /></Suspense> },
        { path: 'wizard', element: <Suspense fallback={null}><WizardForm /></Suspense> },
        { path: 'customers', element: <Suspense fallback={null}><Customers /></Suspense> },
        { path: 'msp-users', element: <Suspense fallback={null}><MspUsers /></Suspense> },
        { path: 'sa-monitor', element: <Suspense fallback={null}><SAMonitor /></Suspense> },
        { path: 'view-apps', element: <Suspense fallback={null}><SaasApplications /></Suspense> },
        { path: 'Site-to-Site', element: <Suspense fallback={null}><SitetoSite /></Suspense> },
        { path: 'view-agents', element: <Suspense fallback={null}><ViewAgents /></Suspense> },
        // { path: 'view-license', element: <Suspense fallback={null}><ViewLicenseComponent /></Suspense> },
        // reports path
        { path: 'reports', element: <Suspense fallback={null}><NewReports /></Suspense> },
        { path: 'internal-probes', element: <Suspense fallback={null}><InternalProbes /></Suspense> },
        { path: 'probe-location-mapping', element: <Suspense fallback={null}><ProbeLocationMapping /></Suspense> },
        { path: 'cloud', element: <Suspense fallback={null}><Cloud /></Suspense> },
        { path: 'cloud/toal-cloud-assets/:id', element: <Suspense fallback={null}><TotalCloudAssets /></Suspense> }
      ]
    },
    {
      path: '/logout',
      element: <Suspense fallback={null}><LogoOnlyLayout /></Suspense>
    },
    {
      path: 'forgot-password',
      element: <Suspense fallback={null}><ForgotPassword /></Suspense>
    },
    {
      path: 'validate-otp',
      element: <Suspense fallback={null}><ValidateOtp /></Suspense>
    },
    {
      path: 'reset-password',
      element: <Suspense fallback={null}><ResetPassword /></Suspense>
    },
    {
      path: 'enter-otp',
      element: <Suspense fallback={null}><EnterOtp /></Suspense>
    },
    {
      path: '*', // Catch-all for 404
      element: <Suspense fallback={null}><PageNotFound /></Suspense>
    },
    {
      path: 'wizard-form', element: <Suspense fallback={null}><WizardLayout /></Suspense>
    },
  ];

  return (
    <TourProvider
      steps={steps}
      currentStep={step}
      beforeClose={closeTour}
      afterOpen={disableBody}
      setCurrentStep={setCurrentStep}
      disableInteraction={false}
    >
      {useRoutes(routes)}
    </TourProvider>
  );
}